import React from 'react'
import Layout from '../components/Layout'
import Privacy from '../components/Privacy'

export default () => (
    <Layout title="Privacy Policy - Epicron Digital">
        <Privacy />
    </Layout>
)